// extracted by mini-css-extract-plugin
export var ticker = "ticker-module--ticker--1GmHc";
export var item = "ticker-module--item--3yaI8";
export var svg = "ticker-module--svg--24q6c";